require("core-js/features/array/find");

import Vue from "vue";
import { Component } from "vue-property-decorator";
import { IContractSettings } from "../../new-contract-vuex-store";
import FormGroupStatic from "../phases/form-group-static.vue";
import HorizontalFormGroup from "../phases/horizontal-form-group.vue";
import ContractPartnerCard from "./components/contract-partner-card.vue";
import { IMeteringPointViewModel, IContractViewModel, ICustomerViewModel, ICompanyViewModel, IMembershipTypeViewModel, IContractMembershipViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { CustomerTypeEnum, InvoicingMethodEnum } from "../../../../../Scripts/inpulse/CommonEnums";
import { AddressFormat } from "../../../../../Scripts/inpulse/AddressFormat";
import { ContractTypeFormat } from "../../../../../Scripts/inpulse/FormatUtils";
import { TranslateResult } from "vue-i18n";
import { GenericTypeFormatTranslator, InvoicingMethodFormat } from "../../../../../Scripts/inpulse/FormatUtils";
import { Styles } from "@fortawesome/fontawesome-svg-core";

@Component({
    components: {
        FormGroupStatic,
        HorizontalFormGroup,
        ContractPartnerCard
    },
    filters: {
        date(value) {
            let m = moment(value);
            if (m.isValid())
                return m.format("DD.MM.YYYY");
            return value;
        }
    }
})

export default class MeteringPointInformationDisplay extends Vue {
    get contractSettings(): IContractSettings { return this.$store.state.contractSettings; }
    get contract(): IContractViewModel { return this.$store.state.contract; }
    get meteringPoint(): IMeteringPointViewModel { return this.contract.MeteringPoint; }
    get customer(): ICustomerViewModel { return this.contract.Customer; }
    get company(): ICompanyViewModel { return this.contract.Company; }
    get isInvoicingMethodsInUse(): boolean { return this.contractSettings.InvoicingMethodsInUse; }
    get additionalAddressToMeteringPointAddress(): boolean { return this.contract.MeteringPoint.AdditionalAddressToMeteringPointAddress; }
    get membership(): IContractMembershipViewModel { return this.contract.ContractMembership; }

    AddressFormat: typeof AddressFormat = AddressFormat;
    CustomerTypeEnum: typeof CustomerTypeEnum = CustomerTypeEnum;
    InvoicingMethodEnum: typeof InvoicingMethodEnum = InvoicingMethodEnum;
    ContractTypeFormat: typeof ContractTypeFormat = ContractTypeFormat;

    get addressString(): string {
        return AddressFormat.toSingleString(this.meteringPoint.Address);
    }

    get homeAddressString(): string {
        return (this.contract.CustomerType == CustomerTypeEnum.COMPANY) ? AddressFormat.toSingleString(this.company.Address) : AddressFormat.toSingleString(this.customer.Address);
    }

    get invoicingAddressString(): string {
        if (this.contract.InvoicingAddress.ContactPersonName != null && this.contract.InvoicingAddress.ContactPersonName != "") {
            return this.contract.InvoicingAddress.ContactPersonName + ", " + AddressFormat.toSingleString(this.contract.InvoicingAddress.Address);
        }
        return AddressFormat.toSingleString(this.contract.InvoicingAddress.Address);
    }

    get invoicingMethodString(): string | TranslateResult {
        return GenericTypeFormatTranslator.toString(InvoicingMethodFormat.toString, this.contract.InvoicingMethod, this.$i18n);
    }

    get invoicingECompanyAddressString(): string {
        if (this.contract.InvoicingAddress.InvoicingNetworkAddress !== null && this.contract.InvoicingAddress.InvoicingOperator !== null) {
            return this.contract.InvoicingAddress.InvoicingNetworkAddress + " " + this.contract.InvoicingAddress.InvoicingOperator;
        }
        else {
            return "";
        }
    }

    get tooltipStyle(): Styles {
        if (this.additionalAddressToMeteringPointAddress) {
            return { color: 'red' };
        }
        return { color: 'white' };
    }

    get memberShipName(): string {
        if (this.membership && this.membership.MembershipName) {
            let membershipTypes = this.$store.state.membershipTypes as IMembershipTypeViewModel[];
            if (membershipTypes) {
               return membershipTypes.find(m => m.MembershipTypeId == this.membership.MembershipType).Name;
            }
        }
        return null;
    }

}